"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _const = require("../../../const");

var _helpers = require("../../../helpers");

var _const2 = require("../components/slide-content/const");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n\n  &:not(:last-of-type) {\n    margin-bottom: 15px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ButtonWrap = (0, _uiKit.styled)('div')(_templateObject());

var Buttons = function Buttons(_ref) {
  var colorDefault = _ref.color,
      buttons = _ref.buttons;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, buttons && buttons.map(function (_ref2, index) {
    var link = _ref2.link,
        text = _ref2.text,
        type = _ref2.type,
        buttonColor = _ref2.buttonColor;
    var _heroSlideButtonsProp = _const2.heroSlideButtonsProps[buttonColor || _const2.HeroSlideButtonColor.WHITE_GHOST],
        variant = _heroSlideButtonsProp.variant,
        color = _heroSlideButtonsProp.color;
    return /*#__PURE__*/_react.default.createElement(ButtonWrap, _extends({
      key: index
    }, {
      color: buttonColor ? color : colorDefault
    }), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      as: "a",
      href: link,
      color: buttonColor ? color : _const.ButtonContrast[colorDefault],
      variant: buttonColor ? variant : (0, _helpers.getButtonStyleByType)(type),
      fullWidth: true
    }, text));
  }));
};

var _default = Buttons;
exports.default = _default;